<div class="ub ub-ver fw flow-print" :class="{'in-iframe':isIframe}">
  <div class="ub fw ub-ac ub-pc zhezhao detail-load" v-if="loading">
    <a-spin :spinning="loading" class="ub spin-loading detail-load-spin"></a-spin>
  </div>
  <div class="ub ub-ver fw print-div" id="flow-print-table">
    <template v-for="(item,index) in loopSection" :key="index">
      <slot name="header" v-if="item.show&&item.value==='header'" :record="basicInfo">
        <div class="ub ub-ver ub-ac ub-pc fw bgfff header">
          <div class="ub ub-ac ub-ps sub-title fw">
            <slot name="subTitle" :record="basicInfo">
              <div class="ub ub-ac ub-ps">
                <a-space :size="60">
                  <div class="ub ub-ac ub-pc item biz-no">
                    <div class="ub ub-ac ub-pc item-title">{{bizNoLabelName}}：</div>
                    <div class="ub ub-ac ub-pc item-content">{{basicInfo?.bizNo}}</div>
                  </div>
                  <div
                    class="ub ub-ac ub-pc item valid-status"
                    v-if="validStatusLabelName?.length>0"
                  >
                    <div class="ub ub-ac ub-pc item-title">{{validStatusLabelName}}：</div>
                    <div class="ub ub-ac ub-pc item-content">
                      {{basicInfo?.statusName??basicInfo?.validStatusName}}
                    </div>
                  </div>
                  <div class="ub ub-ac ub-pc item valid-status" v-if="useNew&&(basicInfo?.projectStatusName||basicInfo?.statusName)">
                    <div class="ub ub-ac ub-pc item-title">项目状态：</div>
                    <div class="ub ub-ac ub-pc item-content">
                      {{basicInfo?.projectStatusName??basicInfo?.statusName}}
                    </div>
                  </div>
                  <div class="ub ub-ac ub-pc item flow-status">
                    <div class="ub ub-ac ub-pc item-title">审批状态：</div>
                    <div class="ub ub-ac ub-pc item-content">
                      {{basicInfo?.flowStatusName}}
                    </div>
                  </div>
                  <div
                    class="ub ub-ac ub-pc item flow-status"
                    v-if="useNew&&contractStatusLabelNameKey?.length>0"
                  >
                    <div class="ub ub-ac ub-pc item-title">合同状态：</div>
                    <div class="ub ub-ac ub-pc item-content">
                      {{contractStatusLabelNameKey}}
                    </div>
                  </div>
                </a-space>
              </div>
            </slot>
          </div>
        </div>
      </slot>
      <slot name="tabHeader" :record="basicInfo"  v-if="item.show&&item.value==='tabHeader'">

      </slot>
      <print-item
        :class="[index==1?'first-print-item':'',index==loopSection.length-1?'last-print-item':'']"
        v-if="item.show && item.value !=='header'&& item.value !=='tabHeader' && item.value !== 'qrcode'&&((item?.visible&&item?.visible(basicInfo))??true)"
      >
        <template #header> {{item.label}}</template>
        <template #body>
          <slot :name="item.value" :record="basicInfo">
            <attachment
              v-if="item.value === 'attach' && item.show"
              v-model:value="attachList"
              :biz-id="id"
              :biz-type="attachBizType"
            ></attachment>
            <approval-flow-log-table
              v-if="item.value==='flow' && item.show"
              :biz-id="id"
              :biz-type="flowBizType"
              v-model:value="dataSource"
            ></approval-flow-log-table>
          </slot>
        </template>
      </print-item>
    </template>
    <div class="interval-footer"></div>
    <div
      class="ub ub-ac ub-pc fw detail-footer"
      :style="{width:isIframe?'calc(100% + 32px)':(collapsed?'calc(100% - 80px)':'calc(100% - 200px)'),left:isIframe?'-16px':(collapsed?'80px':'200px')}"
    >
      <a-space>
        <slot name="footer" v-if="showFooter" :record="basicInfo">
          <!-- showEditBtn{{showEditBtn && basicInfo?.status !== 'ygb'}}{{basicInfo?.status}} -->
          <!-- <template v-if="showEdit"> -->
          <a @click="goto(editUrl+'/edit/'+id)" v-perm="editPerm">
            <a-button v-if="showEdit&&!useNew">编辑</a-button>
          </a>
          <!-- </template> -->
          <template v-if="!useNew">
            <approval-flow-btn
              :examine-access="examinePerm"
              v-if="bizName && status !== 'ygb'"
              :biz-id="id"
              :eventName="listComponentName"
              :createBy="createBy"
              v-model:showEditBtn="showEditBtn"
              v-model:flowStatus="flowStatus"
              v-model:flowType="flowType"
              :biz-type="flowBizType"
              :biz-name="bizName"
              @refreshApprovalDetail="refresh"
              :disabledVoid="disabledVoid"
              :record="basicInfo"
            ></approval-flow-btn>
          </template>

          <detail-btns
            v-if="useNew&&bizName"
            :biz-type="flowBizType"
            :flowStatusKeyName="flowStatusKeyName"
            :biz-name="bizName"
            :record="recordNameKey?basicInfo[recordNameKey]:basicInfo"
            :url="url"
            :editPerm="editPerm"
            :editUrl="editUrl"
            :createBy="createBy"
            @refresh="refresh"
            :examine-access="examinePerm"
            :recoverAccess="recoverAccess"
            :completelyDeleteAccess="completelyDeleteAccess"
            :deleteAccess="deleteAccess"
            :bizNameKey="bizNameKey"
            :statusKey="statusKey"
            :changePerm="changePerm"
            :other="other"
          ></detail-btns>
          <template
            v-if="showLostOrderBtn && basicInfo?.status !== 'ygb' && flowBizType==='project_examine'"
          >
            <Lost-orderBtn
              v-perm="examinePerm"
              :biz-id="id"
              :biz-type="flowBizType"
              :biz-name="bizName"
              @refresh="refresh"
              class="margin-left-14px"
            ></Lost-orderBtn>
          </template>
          <a-button @click="goPrint" class="ml14">打印</a-button>
          <slot name="footer-external"></slot>
        </slot>
      </a-space>
    </div>
  </div>
</div>
